import { http } from "../framework/api";
import config from "../config";

export const validateSessionIdentity = (firstName, lastName, dateOfBirth) => {
  const url = `${config.API_ROOT_URL}/sessions/validate-identity`;
  return http("POST", url, { firstName, lastName, dateOfBirth });
};
